import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';
import {browserHistory} from "react-router";
import I18n from "lib/i18n/i18n";
import WorthyApi from "lib/api/worthyApi";
import WorthyApiErrors from 'lib/api/worthyApiErrors';
import UserActions from 'lib/userActions';
import {getUserBundles, clearSelectedBundle, getBundleWithItems} from 'actions/myAccount';
import BundleDetails from 'components/myAccount/bundleDetails';
import Login from 'components/login';
import NoMatch from "components/noMatch";
import rootStore        from 'reducers';
import MyItemsSkeleton from './myItemsSkeleton';
import {appUrl} from '../../helpers/ApplicationHelper';
import { getItemsCount } from '../../actions/itemsCount';
import GenerateEstimationLoader from 'components/item/misc/generateEstimationLoader';

class MyAccount extends Component {
    constructor(props) {
        super(props);
        this.rerenderParentCallback = this.rerenderParentCallback.bind(this);
        this.state = {
            bundles: props.MyAccount && props.MyAccount.bundles || [],
            isLoading: false,
            open: false
        };
    }

    componentWillReceiveProps(newProps) {
        if (!(this.props.Session && this.props.Session.isLoggedIn) && newProps.Session && newProps.Session.isLoggedIn)
            !this.props.selectedBundle && UserActions.myAccount("Seller viewed 'My jewelry box'");
        if (!this.dataFetched && this.props.Session && this.props.Session.isLoggedIn) {
            this.dataFetched = true;
            if (this.props.selectedBundle) {
                this.props.getBundleWithItems(this.props.selectedBundle);
                this.props.getUserBundles(this.props.Session.userData.id);

                WorthyApi.resetNotificationsCounter(this.props.selectedBundle);
            }
            else if (!newProps.MyAccount || !newProps.MyAccount.bundles) {
                this.props.getUserBundles(this.props.Session.userData.id).then((res) => {
                    this.setState({bundles: res.payload});
                })
            }
        }
        if (this.props.MyAccount && !this.props.MyAccount.bundles && newProps.MyAccount.bundles)
            this.setState({ bundles: newProps.MyAccount.bundles });
    }

    back = () => {
        console.log('Go to items page');
        browserHistory.push('/items');
        this.props.clearSelectedBundle();
    }

    backAfterCancellation = () => {
        this.setState({isLoading: true});
        this.props.getUserBundles(this.props.Session.userData.id).then((res) => {
            this.setState({bundles: res.payload, isLoading: false});
            rootStore.dispatch(getItemsCount(this.props.Session.userData.id))
            console.log('return back');
            browserHistory.push('/items');
            this.props.clearSelectedBundle();
        })

    }

    renderData() {
        if (this.props.MyAccount.selectedBundle) { // render single bundle page
            const bundle = this.props.MyAccount.selectedBundle;
            if (bundle?.converted_from_std_bundle && bundle?.pre_delivered) {
                window.location.href = appUrl('/item/' + bundle.main_item_id);
                return;
            }
            return <BundleDetails bundle={bundle} back={this.backAfterCancellation} count={bundle.count} open={true} rerenderParentCallback={this.rerenderParentCallback}/>
        } else { // render all user bundles page
            return this.state.bundles.map((bundle, i) => {
                const itemPublicId = (bundle.count || bundle.items.length) === 1 ? bundle.single_item.public_id : null;
                return <div key={`${itemPublicId+i}`}>
                    <BundleDetails first={i === 0} key={itemPublicId} bundle={bundle} itemPublicId={itemPublicId} count={bundle.count} rerenderParentCallback={this.rerenderParentCallback}/>
                </div>


            })
        }
    }

    rerenderParentCallback() {
            this.setState({isLoading: true})
            this.props.getUserBundles(this.props.Session.userData.id).then((res) => {
                this.setState({bundles: res.payload, isLoading: false});
                rootStore.dispatch(getItemsCount(this.props.Session.userData.id))
            })

    }

    render() {
        if (!this.props.Session) return <MyItemsSkeleton/>;
        if (!this.props.MyAccount) {
            if (this.props.Session.isLoggedIn) {
                return <MyItemsSkeleton/>;
            } else {
                return (
                    <Login
                        onLoginSuccessful={() => {

                        }}
                        showLinkToRegister={true} />
                )
            }
        } else {
            if (this.props.MyAccount.selectedBundle instanceof WorthyApiErrors)
                return <NoMatch/>;
            else
                return (
                    this.props.MyAccount.selectedBundle && this.state.isLoading?
                        (<GenerateEstimationLoader className={'cancel-item-loader'}/>)
                        :
                    (<div id='my-account-container'>
                        <div className='banner'/>
                        <div className='page-header'>
                            {
                                this.props.MyAccount.selectedBundle ?
                                    <a className='back' onClick={this.back}>My jewelry box</a>
                                    :
                                    <h1>{I18n.getString('myAccount::title')}</h1>
                            }
                        </div>
                        {
                            this.renderData()
                        }

                    </div>)
                );
        }
    }
}

const mapStateToProps = ({Session, ADO, MyAccount}) => {
    return {Session, ADO, MyAccount}
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({getUserBundles, clearSelectedBundle, getBundleWithItems}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);
